import { Injectable, inject } from '@angular/core';
import { driver } from 'driver.js';
import type { Driver } from 'driver.js';
import { catchError, of } from 'rxjs';
import { Router } from '@angular/router';
import { ApiService } from './api.service';
import { WALKTHROUGH_TOURS, ROUTE_TOUR_MAP } from '../components/walkthrough/walkthrough.config';

@Injectable({ providedIn: 'root' })
export class WalkthroughService {
  private api = inject(ApiService);
  private router = inject(Router);
  private _driver: Driver | null = null;

  checkAndLaunch(): void {
    this.api.get<any>('me', { prefix: 'monicase/read/' }).pipe(
      catchError(() => of(null))
    ).subscribe(res => {
      const user = res?.data;
      if (!user) return;
      const seen = user.custom_attributes?.walkthrough_seen;
      if (seen?.global) return;
      setTimeout(() => this.launch('global'), 1000);
    });
  }

  launch(tourId: string): void {
    const tour = WALKTHROUGH_TOURS[tourId];
    if (!tour) return;

    this._driver?.destroy();

    // Filtrer les steps dont l'élément cible n'existe pas dans le DOM
    const steps = tour.steps.filter(step => {
      if (!step.element) return true;
      return !!document.querySelector(step.element as string);
    });

    if (!steps.length) return;

    this._driver = driver({
      showProgress: true,
      nextBtnText: 'Suivant →',
      prevBtnText: '← Précédent',
      doneBtnText: 'Terminer',
      progressText: '{{current}} / {{total}}',
      onDestroyStarted: () => {
        this._markAsSeen(tourId);
        this._driver?.destroy();
      },
      steps,
    });

    this._driver.drive();
  }

  launchForCurrentRoute(): void {
    const url = this.router.url;
    const match = ROUTE_TOUR_MAP.find(r => r.pattern.test(url));
    this.launch(match ? match.tourId : 'global');
  }

  private _markAsSeen(tourId: string): void {
    this.api.post<any>('me/walkthrough', { tour_id: tourId }, 'monicase/edit/').subscribe();
  }
}
